import { gql } from '@apollo/client';

export interface ReportProductsByReportIdResponse {
  allReportJobs: {
    nodes: {
      reportSummariesByReportId: {
        edges: {
          node: {
            productByProductId: {
              id: number;
            };
          };
        }[];
      };
    }[];
  };
}

export default gql`
  query ReportProductsByReportId($reportId: UUID!) {
    allReportJobs(condition: { reportId: $reportId }) {
      nodes {
        reportSummariesByReportId {
          edges {
            node {
              productByProductId {
                id
              }
            }
          }
        }
      }
    }
  }
`;
